// extracted by mini-css-extract-plugin
module.exports = {"booking-bar":"BookingBar_booking-bar__PdjDb","arrow":"BookingBar_arrow__skycJ","label":"BookingBar_label__MsOhZ"};